export default __webpack_public_path__ + "static/media/copyIcon.df37011b.svg";